export default class InViewContainerCtrl {
  callbacks = [];
  windowHasFocus = true;
  elem = undefined;

  constructor($window) {
    angular.element($window).focus(() => (this.windowHasFocus = true));
    angular.element($window).blur(() => (this.windowHasFocus = false));
  }

  /**
   * Set the DOM element this directive is marked with, allowing the callback
   * function in registerCallback to be called on load.
   * @param elem
   */
  setElem(elem) {
    this.elem = elem;
  }

  registerCallback(cb) {
    if (this.elem) {
      cb(this.elem);
    }

    this.callbacks.push(cb);

    return () => {
      const idx = this.callbacks.indexOf(cb);

      this.callbacks = [...this.callbacks.slice(0, idx), ...this.callbacks.slice(idx + 1)];
    };
  }
}
